import { logError } from 'utils/logger';
import { useMutation } from '@apollo/client';
import { FetchOptionsCallback } from 'global';

import { UPDATE_CREDIT_SUBMISSION, POST_CREDIT_DECISION } from '../api';

export function useCreditSubmission() {
  const [onUpdateCreditSubmission, { loading }] = useMutation(UPDATE_CREDIT_SUBMISSION);

  const handleUpdateCreditSubmission = async (dynamicsCreditSubmissionId: string, fieldsObj: Record<string, any>) => {
    if (!dynamicsCreditSubmissionId) return;

    try {
      await onUpdateCreditSubmission({ variables: { input: { dynamicsCreditSubmissionId, ...fieldsObj } } });
    } catch (error) {
      logError(error);
    }
  };

  const [onPostCSDecision, { loading: isCSDecisionPosting }] = useMutation(POST_CREDIT_DECISION);

  const handlePostCSDecision = async (
    dynamicsCreditSubmissionId: string,
    fieldsObj: Record<string, any>,
    fetchOptions?: FetchOptionsCallback<{}>
  ) => {
    if (!dynamicsCreditSubmissionId) return;

    try {
      await onPostCSDecision({
        variables: { fieldsObj, entityId: dynamicsCreditSubmissionId },
        ...(typeof fetchOptions == 'function' ? fetchOptions({}) : {}),
      });
    } catch (error) {
      logError(error);
    }
  };

  return {
    isUpdating: loading,
    handleUpdateCreditSubmission,
    handlePostCSDecision,
    isCSDecisionPosting,
  };
}
